import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch, computed, nextTick } from 'vue'
import { useToastQueueStore } from '@/components/BsToastQueueStore'
import BsToast from '@/components/BsToast/BsToast.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BsToastQueue',
  props: {
    pollDelay: { default: 250 }
  },
  setup(__props: any) {

const props = __props

const { state, actions } = useToastQueueStore()
const isOpen = ref(false)
const head = computed(() => state.head)

watch(isOpen, (isOpenValue) => {
  if (!isOpenValue) {
    setTimeout(() => {
      actions.poll()
    }, props.pollDelay)
  }
})

watch(head, async (headValue) => {
  if (headValue) {
    await nextTick()
    isOpen.value = true
  }
})

return (_ctx: any,_cache: any) => {
  return (head.value)
    ? (_openBlock(), _createBlock(BsToast, {
        key: 0,
        isOpen: isOpen.value,
        "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
        position: head.value.position,
        type: head.value.type,
        title: head.value.title,
        message: head.value.message
      }, null, 8, ["isOpen", "position", "type", "title", "message"]))
    : _createCommentVNode("", true)
}
}

})